import {selectUserPanel} from '../../selector'
import {createSelector} from 'reselect'

export const selectWorkStatuses = (state) => selectUserPanel(state).workStatuses

export const getWorkStatuses = createSelector(
    selectWorkStatuses,
    (workStatuses) => {
        return workStatuses.workStatuses
    }
)

export const getDefaultWorkStatusPlanningData  = createSelector(
    selectWorkStatuses,
    (workStatuses) => {
        return workStatuses.defaultWorkStatusPlanningData
    }
)
export const getInitialDefaultWorkStatus  = createSelector(
    selectWorkStatuses,
    (workStatuses) => {
        return workStatuses.initialDefaultWorkStatus
    }
)




// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workStatuses/selectors.js